import { FramerPage } from 'Pages/FramerPage';

const McpGuide = () => <FramerPage path="help-center/mcp-guide" />;

export default McpGuide;
